import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
const COLORS = ["#2563EB", "#16A34A", "#DC2626"];
const StatsChart = ({ stats }) => {
  const data = [
    { name: "Submitted", value: stats.submitted },
    { name: "Approved",  value: stats.approved },
    { name: "Rejected",  value: stats.rejected },
  ].filter((d) => d.value > 0);
  if (!data.length) return null;
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <h3 className="text-base font-semibold text-gray-800 mb-4">Application Breakdown</h3>
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie data={data} dataKey="value" cx="50%" cy="50%" outerRadius={90} innerRadius={40} paddingAngle={3} label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`} labelLine={false}>
            {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
          </Pie>
          <Tooltip formatter={(value) => [value, "Applications"]} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
export default StatsChart;